export default "__VITE_ASSET__CpoQo$bS__"